import { IPropertyStorage } from '../Property/propertyStorage';
import Property from '../Property/Property';
import TimerPropertyStorage from './TimerPropertyStorage';
import { ProprietaryTimerType } from '@signageos/common-types/dist/Device/Timer/ProprietaryTimerType';
import { ProprietaryTimer } from '@signageos/common-types/dist/Device/Settings/DeviceSettings';

export default class ProprietaryTimerPropertyStorage extends TimerPropertyStorage<ProprietaryTimer, ProprietaryTimerType> {
	constructor(propertyStorage: IPropertyStorage) {
		super(propertyStorage, Property.TIMER_SETTINGS);
	}
}
